import { createApp } from 'vue';
import PefToPngConverter from '../Components/PefToPngConverter.vue';

const root = document.getElementById('pef-to-png-converter');
if (root) {
  createApp(PefToPngConverter).mount('#pef-to-png-converter');
}
